import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/observable/from';
import React, {createElement} from 'react';
import {mapPropsStream} from 'recompose';


export const contextTypes = {
  store: (props, propName) => {
    // custom validation via Observable.from
    try {
      Observable.from(props[propName]);
    } catch (e) {
      return new Error('fuse() error: context.store must implement observable');
    }
    return null;
  }
};

export default propStream$ => (StreamedComponent) => {
  class ComponentFromStream extends React.Component {
    constructor(props, context) {
      super(props, context);
      const {store} = context;
      if (!store) {
        throw new Error(
          `fuse() error: Missing Redux store in context.
           Did you forget to <Provide> it?`
        );
      }

      this.lifeCycleStreams = {
        componentDidMount: new Subject(),
        componentWillUnmount: new Subject(),
      };

      this.WrappedComponent = mapPropsStream(
        propStream$(store.state$, store.dispatch, {
          componentDidMount$: this.lifeCycleStreams.componentDidMount.asObservable(),
          componentWillUnmount$: this.lifeCycleStreams.componentWillUnmount.asObservable(),
        })
      )(StreamedComponent);
    }

    componentDidMount() {
      this.lifeCycleStreams.componentDidMount.next(this.props);
    }

    componentWillUnmount() {
      this.lifeCycleStreams.componentWillUnmount.next(this.props);
      this.lifeCycleStreams.componentDidMount.complete();
      this.lifeCycleStreams.componentWillUnmount.complete();
    }

    render() {
      return createElement(this.WrappedComponent, this.props);
    }
  }

  ComponentFromStream.contextTypes = contextTypes;

  return ComponentFromStream;
}



// WEBPACK FOOTER //
// ./src/js/_libs/redux-fusion/lifeCycle.js